import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { Country } from '../country-options';
import { TREATMENTS } from '../toggles-definition';
import { SplitFeatureToggles } from './sdk';
var getToggle = SplitFeatureToggles.getToggle,
    initialize = SplitFeatureToggles.initialize,
    setClient = SplitFeatureToggles.setClientId;
export var setClientId = setClient;
var GATSBY_SPLIT_KEY_CO = process.env.GATSBY_SPLIT_KEY_CO;
var GATSBY_SPLIT_KEY_BR = process.env.GATSBY_SPLIT_KEY_BR;
export var InitializeSplit = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(country) {
    var splitKey;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            splitKey = country === Country.BR ? GATSBY_SPLIT_KEY_BR : GATSBY_SPLIT_KEY_CO;

            if (splitKey) {
              _context.next = 3;
              break;
            }

            throw 'SPLIT_KEY is not set, please check your .env';

          case 3:
            _context.next = 5;
            return initialize(splitKey);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function InitializeSplit(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getSplitToggle = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(country) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return InitializeSplit(country);

          case 2:
            return _context2.abrupt("return", {
              getPreapprovalVersion: function getPreapprovalVersion(ctx) {
                return getToggle(TREATMENTS.preApprovalVersion, ctx).getValue();
              },
              corresponsalWompiEnabled: function corresponsalWompiEnabled(ctx) {
                return getToggle(TREATMENTS.corresponsalWompiEnabled, ctx).isEnabled();
              },
              enablePseAmountOptions: function enablePseAmountOptions(ctx) {
                return getToggle(TREATMENTS.enablePseAmountOptions, ctx).isEnabled();
              },
              disableAppSucursalBanColombia: function disableAppSucursalBanColombia(ctx) {
                return getToggle(TREATMENTS.disableAppSucursalBanColombia, ctx).isEnabled();
              },
              enableDruoSection: function enableDruoSection(ctx) {
                return getToggle(TREATMENTS.enableDruoSection, ctx).isEnabled();
              },
              enablePSEPayment: function enablePSEPayment(ctx) {
                return getToggle(TREATMENTS.enablePSEPayment, ctx, true).isEnabled();
              },
              enableCorresponsalPayment: function enableCorresponsalPayment(ctx) {
                return getToggle(TREATMENTS.enableCorresponsalPayment, ctx, true).isEnabled();
              },
              enableBannerHowToPayTwoEmbedded: function enableBannerHowToPayTwoEmbedded(ctx) {
                return getToggle(TREATMENTS.enableBannerHowToPayTwoEmbedded, ctx, false).isEnabled();
              },
              enableBannerHowToPayTwoEmbeddedBR: function enableBannerHowToPayTwoEmbeddedBR(ctx) {
                return getToggle(TREATMENTS.enableBannerHowToPayTwoEmbeddedBR, ctx, false).isEnabled();
              },
              unavailableBanks: function unavailableBanks(ctx) {
                return getToggle(TREATMENTS.unavailableBanks, ctx).getValue();
              },
              enableWompiWidgetIntegritySignature: function enableWompiWidgetIntegritySignature(ctx) {
                return getToggle(TREATMENTS.enableWompiWidgetIntegritySignature, ctx).isEnabled();
              },
              enableEmbeddedWompiWidgetIntegritySignature: function enableEmbeddedWompiWidgetIntegritySignature(ctx) {
                return getToggle(TREATMENTS.enableEmbeddedWompiWidgetIntegritySignature, ctx).isEnabled();
              }
            });

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getSplitToggle(_x2) {
    return _ref2.apply(this, arguments);
  };
}();